/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { createApiAction } from 'api/core';

export const getRemittanceToken = createApiAction({
  method: 'get',
  url: '/api/landing/remittance/code/:code',
  queryStringMapper: r => r,
  responseMapper: r => r
});